import { render, staticRenderFns } from "./IconSvgAddSchedule.vue?vue&type=template&id=56f18ad1&scoped=true&"
import script from "./IconSvgAddSchedule.vue?vue&type=script&lang=js&"
export * from "./IconSvgAddSchedule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f18ad1",
  null
  
)

export default component.exports